import { useEffect, useRef, useState } from 'react';
import { getRoute } from '../../api/routeApi';
import { YSRouteMapWrap } from './YS.styles';

const COLOR = '#0d6efd';

const YSRouteMap = ({ group, type, onClose }) => {
    const mapRef = useRef(null);
    const polylineRef = useRef(null);
    const markersRef = useRef([]);
    const [loading, setLoading] = useState(true);
    const [routeInfo, setRouteInfo] = useState(null);

    useEffect(() => {
        if (!group) return;
        drawRoute();
        return () => clearMap();
    }, [group, type]);

    const clearMap = () => {
        if (polylineRef.current) polylineRef.current.setMap(null);
        markersRef.current.forEach(m => m.setMap(null));
        polylineRef.current = null;
        markersRef.current = [];
    };

    const drawRoute = async () => {
        setLoading(true);
        const container = mapRef.current;
        if (!container) return;

        const tripDest = { lat: 37.3419823, lon: 127.2885772 };

        // 경로 좌표 구성
        let coords;
        let labels;
        if (type === 'departure') {
            // 드라이버 출발지 → [라이더 출발지들] → 화담숲
            coords = [group.driver.departure];
            labels = [group.driver.name + ' (출발)'];
            group.riders.forEach(r => {
                coords.push(r.departure);
                labels.push(r.name);
            });
            coords.push(tripDest);
            labels.push('화담숲');
        } else {
            // 화담숲 → [라이더 집들] → 드라이버 집
            coords = [tripDest];
            labels = ['화담숲'];
            group.riders.forEach(r => {
                coords.push(r.destination);
                labels.push(r.name);
            });
            coords.push(group.driver.destination);
            labels.push(group.driver.name + ' (집)');
        }

        const route = await getRoute(coords);

        const map = new window.google.maps.Map(container, {
            center: { lat: 37.5, lng: 127.0 },
            zoom: 10,
            disableDefaultUI: true,
            zoomControl: true,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false
        });

        const bounds = new window.google.maps.LatLngBounds();

        // 경로선
        if (route && route.geometry) {
            const path = route.geometry.coordinates.map(([lng, lat]) => ({ lat, lng }));
            polylineRef.current = new window.google.maps.Polyline({
                path,
                strokeColor: COLOR,
                strokeOpacity: 0.8,
                strokeWeight: 4,
                map
            });
            path.forEach(p => bounds.extend(p));
            setRouteInfo({ duration: route.duration, distance: route.distance });
        }

        // 마커
        coords.forEach((c, i) => {
            const pos = { lat: c.lat, lng: c.lon };
            const isFirst = i === 0;
            const isLast = i === coords.length - 1;
            const isTrip = labels[i] === '화담숲';

            const marker = new window.google.maps.Marker({
                position: pos,
                map,
                label: {
                    text: String(i + 1),
                    color: isTrip ? '#fff' : (isFirst || isLast ? '#fff' : COLOR),
                    fontSize: '12px',
                    fontWeight: '700'
                },
                icon: {
                    path: window.google.maps.SymbolPath.CIRCLE,
                    scale: isTrip ? 18 : 14,
                    fillColor: isTrip ? '#198754' : (isFirst || isLast ? COLOR : '#fff'),
                    fillOpacity: 1,
                    strokeColor: isTrip ? '#fff' : COLOR,
                    strokeWeight: isFirst || isLast || isTrip ? 2 : 3
                },
                title: labels[i]
            });

            const infoWindow = new window.google.maps.InfoWindow({
                content: `<div style="font-family:S-Core-Dream;font-size:13px;font-weight:600;padding:2px 4px">${labels[i]}</div>`
            });
            marker.addListener('click', () => infoWindow.open(map, marker));

            markersRef.current.push(marker);
            bounds.extend(pos);
        });

        map.fitBounds(bounds, 50);
        setLoading(false);
    };

    return (
        <YSRouteMapWrap>
            <div className='mapHeader'>
                <span className='mapTitle'>
                    {group.driver.name} 차량 — {type === 'departure' ? '출발' : '귀환'} 경로
                </span>
                <svg className="closeBtn" onClick={onClose} width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <line x1="6" y1="6" x2="18" y2="18" stroke="#495057" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="18" y1="6" x2="6" y2="18" stroke="#495057" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            </div>
            {loading && <div className='mapLoading'>경로 로딩 중...</div>}
            <div className='routeMap' ref={mapRef}></div>
            {routeInfo &&
                <div className='routeInfoBar'>
                    <span>{routeInfo.distance}km</span>
                    <span>{routeInfo.duration}분</span>
                    <span>{group.riders.length + 1}명 탑승</span>
                </div>
            }
        </YSRouteMapWrap>
    );
};

export default YSRouteMap;
